// @flow

import Profile from './profile';
import { User } from '../../models/user';

export type Props = {
  user: User,
  changeProfile: (ProfileId: string) => void,
};

export default Profile;
